import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

export default function RequestAppointmentRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/appointment", { replace: true, state: { matchRequestId: id } });
  }, [id, navigate]);
  return null;
}
